export class ProviderEventEmitter {
    constructor() {
        this.listeners = {
            accountsChanged: [],
            chainChanged: [],
            connect: [],
            disconnect: [],
            display_uri: [],
            message: []
        };
    }
    on(event, listener) {
        this.listeners[event].push(listener);
    }
    removeListener(event, listener) {
        if (event in this.listeners) {
            // @ts-expect-error - Bad typed Provider from core package
            this.listeners[event] = this.listeners[event].filter((l) => l !== listener);
        }
    }
    emit(event, data) {
        if (event in this.listeners) {
            // @ts-expect-error - Bad typed Provider from core package
            this.listeners[event].forEach(listener => listener(data));
        }
    }
}
//# sourceMappingURL=ProviderEventEmitter.js.map